import React from 'react';
import { Link } from 'react-router-dom';

const Seguranca: React.FC = () => {
  const dicas = [
    {
      icon: '🔐',
      titulo: 'Use senhas fortes',
      descricao: 'Crie senhas com letras, números e símbolos. Não use a mesma senha em outros sites.',
    },
    {
      icon: '📧',
      titulo: 'Verifique seu e-mail',
      descricao: 'Mantenha seu e-mail verificado para recuperar sua conta se necessário.',
    },
    {
      icon: '🚫',
      titulo: 'Não compartilhe dados',
      descricao: 'Nunca compartilhe sua senha ou dados pessoais com outros usuários.',
    },
    {
      icon: '💬',
      titulo: 'Negocie pela plataforma',
      descricao: 'Use sempre o chat da BOILX. Evite negociar por outros meios.',
    },
    {
      icon: '👀',
      titulo: 'Verifique o vendedor',
      descricao: 'Confira avaliações e histórico antes de fechar negócio.',
    },
    {
      icon: '🏠',
      titulo: 'Visite presencialmente',
      descricao: 'Quando possível, visite o local e veja o animal antes de pagar.',
    },
  ];

  const alertas = [
    'Desconfie de preços muito abaixo do mercado',
    'Nunca faça pagamentos fora da plataforma',
    'Não clique em links suspeitos enviados por mensagem',
    'Verifique se está no site oficial (boilx.com.br)',
    'Desconfie de urgência excessiva para fechar negócio',
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <div className="bg-gradient-to-br from-green-700 to-green-900 text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Central de Segurança</h1>
          <p className="text-xl text-green-100 max-w-2xl mx-auto">
            Sua segurança é nossa prioridade. Confira dicas para negociar com tranquilidade.
          </p>
        </div>
      </div>

      <div className="container-custom py-12">
        {/* Security Features */}
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Como Protegemos Você</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
                🔒
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Criptografia SSL</h3>
              <p className="text-gray-600 text-sm">Todos os dados são transmitidos com criptografia de ponta.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
                ✅
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Verificação de Usuários</h3>
              <p className="text-gray-600 text-sm">Sistema de verificação de identidade para maior confiança.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-3xl mx-auto mb-4">
                👁️
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Monitoramento 24/7</h3>
              <p className="text-gray-600 text-sm">Equipe dedicada monitorando atividades suspeitas.</p>
            </div>
          </div>
        </div>

        {/* Tips */}
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Dicas de Segurança</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {dicas.map((dica) => (
              <div key={dica.titulo} className="bg-white p-6 rounded-xl shadow-sm">
                <div className="text-3xl mb-3">{dica.icon}</div>
                <h3 className="font-semibold text-gray-900 mb-2">{dica.titulo}</h3>
                <p className="text-gray-600 text-sm">{dica.descricao}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Alerts */}
        <div className="max-w-3xl mx-auto mb-16">
          <div className="bg-amber-50 border border-amber-200 rounded-2xl p-8">
            <div className="flex items-start gap-4">
              <div className="text-3xl">⚠️</div>
              <div>
                <h3 className="text-lg font-bold text-amber-800 mb-4">Sinais de Alerta</h3>
                <ul className="space-y-2">
                  {alertas.map((alerta, index) => (
                    <li key={index} className="flex items-start gap-2 text-amber-700">
                      <span className="text-amber-500">•</span>
                      {alerta}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Report */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-red-50 rounded-2xl p-8 text-center">
            <div className="text-4xl mb-4">🚨</div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Encontrou algo suspeito?</h3>
            <p className="text-gray-600 mb-6">
              Denuncie imediatamente. Nossa equipe analisa todas as denúncias em até 24 horas.
            </p>
            <Link
              to="/contato"
              className="inline-block px-6 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors"
            >
              Reportar Problema
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Seguranca;
